<template>
  <div class="container">
    <div class="container_one" v-loading="oneloading">
      <div class="header">
        
      </div>
      <div class="monthly">
        月能耗(折标煤):
        <span>
          <b >{{monthly}}</b>
          <span style="font-size:18rem">tce</span>
        </span>
      </div>
      <div style="height:20vh">
        <charts id="ElectricityCharts" :option="ElectricityOption"></charts>
      </div>
    </div>
    <div class="container_two" >
      <div class="header">
        <div class="title">月能耗曲线</div>
        <div class="tabs-container">
          <span :class="activeobj.label == item.label ? 'active' : ''" @click="activeobj = item" v-for="(item,index) in downlist" :key="index"
            >{{item.label}}</span
          >
        </div>
      </div>
      <div style="height:28vh"  v-loading="monthloading">
        <charts id="curve" :option="curveOption"  v-if="!iscurveOption"></charts>
        <div  class="row-center tip" v-else style="height:100%"><img :src="require('../../../assets/img/not_found_data.png')" alt=""></div>
      </div>
    </div>
    <div class="container_three">
      <div class="header">
        <div class="title" >本月能耗前十</div>
        <div class="tabs-container">
          <!-- <span :class="isActive == '0' ? 'active' : ''" @click="isActive = '0'"
            >电</span
          >
          <span :class="isActive == '1' ? 'active' : ''" @click="isActive = '1'"
            >水</span
          > 
          <span :class="isActive == '2' ? 'active' : ''" @click="isActive = '2'"
            >热</span
          > 
          <span :class="isActive == '3' ? 'active' : ''" @click="isActive = '3'"
            >冷</span
          >  -->
          <span :class="activeobj.label == item.label ? 'active' : ''" @click="activeobj = item" v-for="(item,index) in downlist" :key="index"
            >{{item.label}}</span
          >
        </div>
      </div>
      <div class="energy"  v-loading="oneloading">
        <ul v-if="EnergyList.length>0&&activeobj.value1!='water'">
          <li v-for="(item, index) in EnergyList" :key="index">
            <div class="name" :title="item.building.name">{{ index + 1 }}.{{ item.building.name }}</div>
            :&nbsp;&nbsp;&nbsp;{{item.power[activeobj.value1].toFixed(2)}} <font v-if="activeobj.value1=='power'">kWh</font><font v-else-if="activeobj.value1=='water'">m³</font><font v-else>GJ</font>
          </li>
        </ul>
        <div  class="row-center tip" v-else-if="activeobj.value1=='water'" style="height: 54%;margin-top: 104px;"><p>未分楼层计量</p><img :src="require('../../../assets/img/not_found_data1.png')" alt="" width="80%"></div>
        <div  class="row-center tip" v-else style="height:100%"><img :src="require('../../../assets/img/not_found_data.png')" alt="" width="80%"></div>
      </div>
    </div>
    <chainratio></chainratio>
  </div>
</template>

<script>
import charts from "../../../components/Energy/charts";
import chainratio from "../../../components/Energy/chain.vue";
import {
    overviewPowerNumber,
    ConsumptionOfProject,
    ConsumptionProportionSC,
    buildingRankings
} from "../../../api/power";
import {
  getTodayTime,
} from "../../../util/date";
import {
  dateFormat,
} from "../../../util/DateUtil";
export default {
  props: {
    routeName: String,
  },
  components: {
    charts,
    chainratio,
  },
  data() {
    return {
      isChain: 1,
      isActive: 0,
      xmonth:[],
      looplist:[],
      monthData:[],
      iscurveOption:false,
      listChart:[],
      oneloading:true,
      monthloading:true,
      activeobj:{
        value: "electricity",
        value1: "power",
        label: "电",
        unit:"kWh",
      },
      downlist: [
        {
          value: "electricity",
          value1: "power",
          label: "电",
          unit:"kWh",
        },
        {
          value: "water",
          value1: "water",
          label: "水",
          unit:"m³",
        },
        {
          value: "heat",
          value1: "heat",
          label: "热",
          unit:"GJ",
        },
        {
          value: "cooling",
          value1: "cooling",
          label: "冷",
          unit:"GJ",
        },
      ],
      monthly:""//月能耗
    };
  },
  computed: {
    
    EnergyList() {
        return this.looplist
    },
     curveOptionData() {{
        return this.monthData
      }
    },
    curveOption() {
      return {
        color: ["#F6BD16", "#F6BD16", "#E8684A", "#6DC8EC"],
        tooltip: {
          trigger: "axis",
          formatter: function(params){
            let str = `${params[0].name}日<br/>`;
            params.forEach((item, idx) => {
              str += `${item.marker}${item.seriesName}: ${item.data}`
              str += idx === params.length -1? '': '<br/>'
            })
            return str
      　　}
        },
        legend: {
          orient: "vertical", //垂直显示
          y: "10%", //延Y轴居中
          x: "right", //居右显示
          icon: "rect",
          align:"left",
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            fontSize: 15,
            fontWeight: 800,
            width:20
          },
          formatter: function(name){
      　　　　return name.length>4?name.substr(0,4)+"...":name;
      　　}
        },
        grid: {
          left: "0%",
          right: "6%",
          bottom: "1%",
          top: "12%",
          containLabel: true,
        },
        xAxis: {
          name:"日",
          nameTextStyle: {
            color: "#999999",
          },
          type: "category",
          boundaryGap: false,
          data: this.xmonth,
          splitLine: {
            show: true,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#CCCCCC",
              width: 1,
              type: "solid",
            },
          },
          axisLabel: {
            //x轴文字的配置
            show: true,
            textStyle: {
              color: "#999999",
            },
          },
        },
        yAxis: {
          type: "value",
          name: this.activeobj.unit,
        },
        series: this.curveOptionData,
      };
    },
    ElectricityOptionData() {
        return this.listChart
    },
    ElectricityOption() {
      return {
        color: ["#0D94FF","#F6BD16", "#E8684A", "#9270CA", "#6DC8EC"],
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return  params.marker +params.name+": " +params.value +"tce"
          }
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            center: ["50%", "50%"],
            label: {
              formatter: "{name|{b}}\n{time|{d}%}",
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 25,
              fontSize: "16rem",
              fontWeight: 800,
              fontWeight: "bold",
              rich: {
                time: {
                  fontSize: "16rem",
                  color: "#0D94FF",
                  fontWeight: "bold",
                },
                name: {
                  fontSize: "16rem",
                  fontWeight: "bold",
                },
              },
            },
            itemStyle: {
              // 此配置
              normal: {
                borderWidth: 2,
                borderColor: "#ffffff",
              },
            },
            labelLine: {
              show: true,
              lineStyle: {
                width: 2,
              },
            },
            data: this.ElectricityOptionData
          },
        ],
      };
    },
  },
  watch:{
    activeobj(n,o){
      this.getLoopData();
      this.getLooplist();
    }
  },
  mounted() {
    for(let i = 0; i <= 30; i++){
				this.xmonth.push(i+1);
		}
    this.getLooplist();
    this.getLooplistMum();
    this.getLoopData();
    this.Getproportion();
  },
  methods: {
    async  getLooplistMum(){
      let response = await overviewPowerNumber();
      let list = response.data.data.list || [];
      let n = 0
      list.map(e=>{ 
        n+=e.sum; 
      })
    },
    //能耗占比
    async Getproportion(){
      let obj = {
        projectId:this.$store.state.project.currentProject.projectId,
        dateRange:"MONTH"
      }
        let response = await ConsumptionProportionSC(obj);
        let data = response.data.data.proportion;
        this.monthly = (data.energySC+data.heatSC+data.waterSC+data.coolingSC).toFixed(2)
       this.listChart = [
        { value: data.energySC.toFixed(2), name: "电", },
        // { value: data.heatSC.toFixed(2), name: "热",},
        { value: data.waterSC.toFixed(2), name: "水", },
        // { value: data.coolingSC.toFixed(2), name: "冷", },
      ];
    },
    //能耗前十
    async  getLooplist(){
        this.oneloading = true
        let obj = {
          powerType:this.activeobj.value.toUpperCase(),
          projectId:this.$store.state.project.currentProject.projectId,
          date:dateFormat("YY-mm-dd",new Date())+'T00:00:00Z',
          dateRange:"MONTH"
        }
        let response = await buildingRankings(obj);
        if(this.activeobj.value=="electricity"){
          this.looplist = response.data.data.list.slice(0,10) || [];
        }else{
          this.looplist = []
        }
        this.oneloading = false
    },
    //月能耗曲线
    async getLoopData(){
      this.monthloading = true
      let time = getTodayTime()
      let obj = {
          date:`${time.today}T00:00:00Z`,
          powerType:this.activeobj.value.toUpperCase(),
          projectId:this.$store.state.project.currentProject.projectId,
          range:"MONTH"
        }
      let response = await ConsumptionOfProject(obj);
      let list = response.data.data.result[this.activeobj.value].map(e=>e!=null?e.toFixed(2):'-') || [];
      if(list.length>0){
        this.iscurveOption = false
      }else{
        this.iscurveOption = true
      }
      this.monthData = [{
          name: this.activeobj.label,
          type: "line",
          areaStyle: {
              color:{
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                      offset: 0, color: 'rgba(246, 189, 22, 0.4)' // 0% 处的颜色
                  }, {
                      offset: 1, color: 'rgba(246, 189, 22, 0)' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
              }
          },
          data:list
        }]
        
      this.monthloading = false
    }
  },
};
</script>

<style scoped lang="less">
.container {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  justify-content: space-between;
  align-content: space-between;
  font-size: 18rem;
  background-color: #F5F7F9;
  .header {
    display: flex;
    justify-content: space-between;
    // padding-left: 24rem;
    // padding-right: 24rem;
    // height: 64rem;
    // line-height: 64rem;
    position: relative;
    .title {
      font-size: 18rem;
      font-weight: 700;
      color: #333;
    }
    .tabs-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      position: absolute;
      right: 0;
      top: -2vh;
      span {
        height: 5vh;
        line-height: 5vh;
        border-top: 2px solid #fff;
        font-size: 18rem;
        font-weight: 400;
        margin: 0 10rem;
        cursor: pointer;
        font-weight: bold;
      }
      .active {
        color: #0d94ff;
        border-top: 2px solid #0d94ff;
      }
    }
  }
  .container_one {
    width: 24vw;
    height: 35vh;
    background: #ffffff;
    padding: 20rem;
  }
  .container_two {
    width: 59vw;
    height: 35vh;
    background: #ffffff;
    padding: 20rem;
  }
  .container_three {
    width: 24vw;
    height: 53.5vh;
    background: #ffffff;
    padding: 20rem;
  }
  .container_four {
    width: 59vw;
    height: 53.5vh;
    justify-content: space-between;
    align-content: space-between;
    display: flex;
    flex-wrap: wrap;
  }
  .chain {
    background: #ffffff;
    padding: 20rem;
    height: 26vh;
    width: 100%;
  }
  .energy {
    height: 46vh;
    li {
      height: 4vh;
      line-height: 4vh;
      margin-top: 8rem;
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);
      font-size: 18rem;
      overflow: hidden;
      .name{
        display: inline-block;
        max-width: 55%;
        text-overflow: ellipsis;
        overflow: hidden;
        vertical-align: -11px;
        white-space: nowrap;
      }
      span {
        // margin-left: 45rem;
        font-weight: bold;
        font-size: 18rem;
        float: right;
        width: 50rem;
        text-align: left;
        img {
          vertical-align: -2px;
        }
      }
    }
  }
  .monthly {
    padding-left: 20rem;
    font-weight: bold;
    background: rgba(0, 43, 102, 0.04);
    border-radius: 12rem;
    line-height: 100rem;
    margin-bottom: 20rem;
    span {
      font-size: 30rem;
      color: #0d94ff;
      font-weight: 400;
      i {
        font-size: 18rem;
      }
    }
  }
  .used {
    padding-top: 20rem;
    padding-left: 30rem;
    float: left;
    .line {
      display: flex;
      margin-bottom: 20rem;
      align-items: center;
      &:before {
        content: "";
        width: 6rem;
        height: 6rem;
        border-radius: 50%;
        background: #666;
        vertical-align: middle;
        margin-right: 10rem;
      }
      .totol {
        font-size: 21rem;
        font-weight: 400;
        color: #666;
        width: 120rem;
        white-space: nowrap;
        display: flex;
        justify-content: space-between;
        i {
          font-style: initial;
        }
      }
      .parameter {
        font-size: 16rem;
        margin-left: 8rem;
        span {
          font-size: 20rem;
          font-weight: bold;
          margin-right: 5rem;
        }
      }
    }
  }
}
</style>
